export default __webpack_public_path__ + "static/media/2_4_0.003db465.png";